import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const getMyAccess = async (query) => {
  const res = await request(getEndpoint("access", "getMyAccess"), { query });
  return res.data;
};

export const checkAccess = async (contentType, contentId) => {
  const res = await request(getEndpoint("access", "checkAccess", contentType, contentId));
  return res.data;
};

export const updatePricing = async (contentType, contentId, payload) => {
  const res = await request(
    getEndpoint("access", "updatePricing", contentType, contentId),
    { body: payload },
  );
  return res.data;
};

export const grantAccess = async (payload) => {
  const res = await request(getEndpoint("access", "grantAccess"), { body: payload });
  return res.data;
};

export const revokeAccess = async (payload) => {
  const res = await request(getEndpoint("access", "revokeAccess"), { body: payload });
  return res.data;
};

export const getAllAccess = async (query) => {
  const res = await request(getEndpoint("access", "getAllAccess"), { query });
  return res.data;
};

export const getContentAccess = async (contentType, contentId, query) => {
  const res = await request(
    getEndpoint("access", "getContentAccess", contentType, contentId),
    { query },
  );
  return res.data;
};

export const getUserAccess = async (userId, query) => {
  const res = await request(getEndpoint("access", "getUserAccess", userId), { query });
  return res.data;
};
